import graphqlClient from "../../../apollo";

class ProductProvider {

    findProduct(id) {
        return graphqlClient.query({
            query: require('./gql/Product/findProduct.graphql'),
            fetchPolicy: "network-only",
            variables: {id:id}
        })
    }

    fetchProduct() {
        return graphqlClient.query({
            query: require('./gql/Product/fetchProduct.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateProduct(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/Product/paginateProduct.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }



    createProduct(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Product/createProduct.graphql'),
            variables: {input}
        })
    }

    updateProduct(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Product/updateProduct.graphql'),
            variables: {id, input}
        })
    }

     deleteProduct(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/Product/deleteProduct.graphql'),
            variables: {id}
        })
    }

}

export default new ProductProvider()


